import { useState, useCallback } from 'react';
import { ModalContextValue, ProfilePublicityModalOptions } from '../ModalContext.types';

export const useProfilePublicityModal = (): ModalContextValue['profilePublicity'] => {
    const [isOpen, setOpen] = useState(false);

    const open = useCallback((_options: ProfilePublicityModalOptions = {}) => {
        setOpen(true);
    }, []);

    const close = useCallback(() => setOpen(false), []);

    return { isOpen, open, close };
};
